// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function callback_request_response_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var result = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "result"), null));
  if (result.TAG === /* Ok */0) {
    var prev_callback_req_id_present = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "prev_callback_req_id_present"), null));
    if (prev_callback_req_id_present.TAG === /* Ok */0) {
      var callback_request_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback_request_id"), null));
      if (callback_request_id.TAG === /* Ok */0) {
        var is_existing_cust = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_existing_cust"), null));
        if (is_existing_cust.TAG === /* Ok */0) {
          var brand = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "brand"), null));
          if (brand.TAG === /* Ok */0) {
            var lead_entry_created = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lead_entry_created"), null));
            if (lead_entry_created.TAG === /* Ok */0) {
              var send_unregistered_event = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "send_unregistered_event"), null));
              if (send_unregistered_event.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          result: result._0,
                          prev_callback_req_id_present: prev_callback_req_id_present._0,
                          callback_request_id: callback_request_id._0,
                          is_existing_cust: is_existing_cust._0,
                          brand: brand._0,
                          lead_entry_created: lead_entry_created._0,
                          send_unregistered_event: send_unregistered_event._0
                        }
                      };
              }
              var e = send_unregistered_event._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".send_unregistered_event" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = lead_entry_created._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".lead_entry_created" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = brand._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".brand" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = is_existing_cust._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_existing_cust" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = callback_request_id._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".callback_request_id" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = prev_callback_req_id_present._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".prev_callback_req_id_present" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = result._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".result" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var fare_estimate_url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fare_estimate_url"), null));
  if (fare_estimate_url.TAG === /* Ok */0) {
    var callback_request_response = callback_request_response_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "callback_request_response"), null));
    if (callback_request_response.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                fare_estimate_url: fare_estimate_url._0,
                callback_request_response: callback_request_response._0
              }
            };
    }
    var e = callback_request_response._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".callback_request_response" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = fare_estimate_url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".fare_estimate_url" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  callback_request_response_decode ,
  t_decode ,
}
/* No side effect */
